(function (global, factory) {
    if (typeof define === "function" && define.amd) {
      define(["exports", "smart/events.m.js", "smart/mixin.m.js", "smart/syncProps.m.js", "smart/table.m.js"], factory);
    } else if (typeof exports !== "undefined") {
      factory(exports, require("smart/events.m.js"), require("smart/mixin.m.js"), require("smart/syncProps.m.js"), require("smart/table.m.js"));
    } else {
      var mod = {
        exports: {}
      };
      factory(mod.exports, global.eventsM, global.mixinM, global.syncPropsM, global.tableM);
      global.gridM = mod.exports;
    }
  })(this, function (_exports, _eventsM, _mixinM, _syncPropsM, _tableM) {
    "use strict";
  
    Object.defineProperty(_exports, "__esModule", {
      value: true
    });
    _exports["default"] = void 0;
    _syncPropsM = _interopRequireDefault(_syncPropsM);
    _tableM = _interopRequireDefault(_tableM);
  
    function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
  
    function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
  
    function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
  
    function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }
  
    function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }
  
    function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
  
    function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }
  
    function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
  
    function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }
  
    function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
  
    function isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
  
    function _construct(Parent, args, Class) { if (isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }
  
    function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }
  
    function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
  
    function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
  
    var Base =
    /*#__PURE__*/
    function (_HTMLElement) {
      _inherits(Base, _HTMLElement);
  
      function Base() {
        var _getPrototypeOf2;
  
        _classCallCheck(this, Base);
  
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
  
        return _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(Base)).call.apply(_getPrototypeOf2, [this].concat(args)));
      }
  
      return Base;
    }(_wrapNativeSuper(HTMLElement));
  
    (0, _mixinM.mix)(Base.prototype, {
      handleEvent: _eventsM.handleEvent,
      on: _eventsM.on,
      off: _eventsM.off,
      fire: _eventsM.fire
    }, _syncPropsM["default"]);
  
    var Grid =
    /*#__PURE__*/
    function (_Base) {
      _inherits(Grid, _Base);
  
      function Grid() {
        var _getPrototypeOf3;
  
        var _this;
  
        _classCallCheck(this, Grid);
  
        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }
  
        // Constructor caveat https://github.com/WebReflection/document-register-element/
        var _ = _this = _possibleConstructorReturn(this, (_getPrototypeOf3 = _getPrototypeOf(Grid)).call.apply(_getPrototypeOf3, [this].concat(args)));
  
        _.init();
  
        return _possibleConstructorReturn(_this, _);
      }
  
      _createClass(Grid, [{
        key: "init",
        value: function init() {
          if (this._isCreated) {
            return;
          }
  
          this._stickyHeader = this.defaults.stickyHeader;
          this._lockedColumns = this.defaults.lockedColumns;
          this._resizable = this.defaults.resizable;
          this.syncProp('stickyHeader');
          this.syncProp('lockedColumns');
          this.syncProp('resizable');
          this._expectedTablesCount = 1;
          this._tablesRendered = 0;
          this.on(['render', 'gridsort', 'sort', 'gridrender', 'gridconnect']);
          this.on(['resize'], this, window);
          this._isCreated = true;
        }
      }, {
        key: "attributeChangedCallback",
        value: function attributeChangedCallback(name, oldValue, newValue) {
          this.init();
  
          switch (name) {
            case 'ongridconnect':
            case 'ongridrender':
            case 'ongridsort':
              var _onabort = this.onabort;
  
              var _onabortAttr = this.getAttribute('onabort');
  
              this.setAttribute('onabort', newValue);
              this[name] = this.onabort;
              this.onabort = _onabort;
  
              if (_onabortAttr == null) {
                this.removeAttribute('onabort');
              } else {
                this.setAttribute('onabort', _onabortAttr);
              }
  
              break;
  
            default:
              this.syncAttr(name, newValue, 'boolean');
          }
        }
      }, {
        key: "connectedCallback",
        value: function connectedCallback() {
          this.init();
          this.fire('gridconnect');
        }
        /**
         * Renders the grid with provided data and optional columns configuration. It generates columns configuration if not given.
         * @param {Array} data Data in the format of Array of JSON
         * @param {?Array} columns Optional column configuration array
         */
  
      }, {
        key: "render",
        value: function render(data, columns) {
          this.clear();
          this.columns = columns || this.generateColumns(data)[0].cols;
          this.renderInnerTables(data, this.columns);
  
          if (this.resizable) {
            this.on(['mousedown', 'touchstart']);
          }
  
          this.fire('render');
        }
      }, {
        key: "clear",
        value: function clear() {
          this.innerHTML = '';
          this._expectedTablesCount = 1;
          this._tablesRendered = 0;
          this.lockedStickyColConfig = null;
          this.lockedColConfig = null;
          this.stickyColConfig = null;
          this.scrollableColConfig = null;
          this.lockedTableData = null;
          this.scrollableTableData = null;
        }
      }, {
        key: "generateColumns",
        value: function generateColumns(data) {
          if (!data[0]) {
            return;
          }
  
          var group = {
            cols: []
          };
  
          for (var key in data[0]) {
            group.cols.push({
              name: key
            });
          }
  
          return [group];
        }
        /**
         * Table that denotes scrollable part of the Grid.
         * @returns {HTMLTableElement} Instance of base Table component.
         */
  
      }, {
        key: "renderInnerTables",
  
        /**
         * Renders individual tables within the grid with provided data and columns configuration. This creates all the required tables and their containers based on the features such as locked, sticky, etc. and renders them accordingly.
         * @param {Array} data Data in the format of Array of JSON
         * @param {Array} columns column configuration array
         */
        value: function renderInnerTables(data, columns) {
          this._lockedHeaders = [];
          this.prepareColumnsConfig(columns);
          this.prepareTablesData(data);
  
          if (this.stickyHeader && this.lockedColumns) {
            this._expectedTablesCount = 4;
            this.lockedStickyTable.render([], this.lockedStickyColConfig);
            this.stickyTable.render([], this.stickyColConfig);
            this.lockedTable.render(this.lockedTableData, this.lockedStickyColConfig);
            this.scrollableTable.render(this.scrollableTableData, this.stickyColConfig);
          } else if (this.lockedColumns) {
            this._expectedTablesCount = 2;
            this.lockedTable.render(this.lockedTableData, this.lockedColConfig);
            this.scrollableTable.render(this.scrollableTableData, this.scrollableColConfig);
          } else if (this.stickyHeader) {
            this._expectedTablesCount = 2;
            this.stickyTable.render([], this.stickyColConfig);
            this.scrollableTable.render(this.scrollableTableData, this.stickyColConfig);
          } else {
            this.scrollableTable.render(this.scrollableTableData, this.scrollableColConfig);
          }
        }
        /**
         * Prepares data for the individual tables in the Grid.
         * @param {Array} data Data in the format of Array of JSON
         */
  
      }, {
        key: "prepareTablesData",
        value: function prepareTablesData(data) {
          for (var i = 0; i < data.length; i++) {
            var rowData = data[i];
  
            for (var cellData in rowData) {
              if (rowData.hasOwnProperty(cellData)) {
                if (this.lockedColumns && this._lockedHeaders.indexOf(cellData) > -1) {
                  this.lockedTableData = this.lockedTableData || [];
                  this.lockedTableData[i] = this.lockedTableData[i] || {};
                  Object.assign(this.lockedTableData[i], _defineProperty({}, cellData, rowData[cellData]));
                } else {
                  this.scrollableTableData = this.scrollableTableData || [];
                  this.scrollableTableData[i] = this.scrollableTableData[i] || {};
                  Object.assign(this.scrollableTableData[i], _defineProperty({}, cellData, rowData[cellData]));
                }
              }
            }
          }
        }
        /**
         * Prepares column configurations for the individual tables in the Grid.
         * @param {Array} columns Data in the format of Array of JSON
         */
  
      }, {
        key: "prepareColumnsConfig",
        value: function prepareColumnsConfig(columns) {
          for (var i = 0; i < columns.length; i++) {
            var col = columns[i];
  
            if (this.stickyHeader && this.lockedColumns && col.locked) {
              this.lockedStickyColConfig = this.lockedStickyColConfig || [{
                cols: []
              }];
              this.lockedStickyColConfig[0].cols.push(col);
  
              this._lockedHeaders.push(col.name);
            } else if (this.lockedColumns && col.locked) {
              this.lockedColConfig = this.lockedColConfig || [{
                cols: []
              }];
              this.lockedColConfig[0].cols.push(col);
  
              this._lockedHeaders.push(col.name);
            } else if (this.stickyHeader) {
              this.stickyColConfig = this.stickyColConfig || [{
                cols: []
              }];
              this.stickyColConfig[0].cols.push(col);
            } else {
              this.scrollableColConfig = this.scrollableColConfig || [{
                cols: []
              }];
              this.scrollableColConfig[0].cols.push(col);
            }
          }
        }
        /**
         * Adjusts the table positions whenever data is changed or screen is resized.
         */
  
      }, {
        key: "adjustTablePositions",
        value: function adjustTablePositions() {
          if (this.lockedColumns) {
            this.adjustLockedTablePosition();
  
            if (this.stickyHeader) {
              this.syncStickyHeader(this.lockedTable, this.lockedStickyHeaderContainer, this.lockedColumnContainer);
            }
          }
  
          if (this.stickyHeader) {
            this.adjustStickyTablePosition();
          }
        }
        /**
         * Synchronizes the widths and scroll position for sticky table with respect to the scrollable table.
         */
  
      }, {
        key: "adjustStickyTablePosition",
        value: function adjustStickyTablePosition() {
          this.syncTableWidths(this.scrollableTable, this.stickyTable);
          this.syncStickyHeader(this.scrollableTable, this.stickyHeaderContainer, this.scrollableContainer);
          this.syncStickyHeaderScroll();
        }
        /**
         * Synchronizes the heights and scroll position for locked table with respect to the scrollable table.
         */
  
      }, {
        key: "adjustLockedTablePosition",
        value: function adjustLockedTablePosition() {
          this.syncLockedTableHeight();
          this.syncLockedTableScroll();
  
          if (this.stickyHeader) {
            this.syncTableWidths(this.lockedTable, this.lockedStickyTable);
          }
        }
        /**
         * Matches the height of the rows in the locked column table and the scrollable table.
         */
  
      }, {
        key: "syncLockedTableHeight",
        value: function syncLockedTableHeight() {
          var fixedTable = this.lockedTable;
  
          if (!fixedTable) {
            return;
          }
  
          var rows = this.scrollableTable.querySelectorAll('tr');
          var fixedRows = fixedTable.querySelectorAll('tr');
  
          for (var i = 0; i < rows.length; i++) {
            var delta = rows[i].clientHeight - fixedRows[i].clientHeight; // We can't reduce row heights so we have to increase them only
  
            var newHeight = rows[i].clientHeight;
  
            if (delta > 0) {
              // original row is higher
              newHeight = fixedRows[i].clientHeight + delta;
            } else if (delta < 0) {
              // fixed row is higher
              newHeight = rows[i].clientHeight - delta; // double negative
            } // We need to fix the height of both rows to protect from further manipulation of content like sorting.
  
  
            rows[i].style.minHeight = newHeight + 'px';
            fixedRows[i].style.minHeight = newHeight + 'px';
            rows[i].style.maxHeight = newHeight + 'px';
            fixedRows[i].style.maxHeight = newHeight + 'px';
            rows[i].style.height = newHeight + 'px';
            fixedRows[i].style.height = newHeight + 'px';
          } // Case when scrollbar appears on scrollable table. Here delta is typically equal to scrollbar height.
  
  
          if (this.lockedColumnContainer.clientHeight != this.scrollableContainer.clientHeight) {
            var _delta = this.lockedColumnContainer.clientHeight - this.scrollableContainer.clientHeight;
  
            this.lockedColumnContainer.style.marginBottom = (parseInt(this.lockedColumnContainer.style.marginBottom) || 0) + _delta + 'px';
          }
        }
        /**
         * Synchronizes the scroll top position of locked container as that of scrollable container and vice versa.
         * @param {HTMLDivElement} target Container on which scroll event was fired.
         */
  
      }, {
        key: "syncLockedTableScroll",
        value: function syncLockedTableScroll(target) {
          var lockedContainer = this.lockedColumnContainer;
          var scrollableContainer = this.scrollableContainer;
          if (lockedContainer.scrollTop == scrollableContainer.scrollTop) return;
  
          if (target == lockedContainer) {
            scrollableContainer.scrollTop = lockedContainer.scrollTop;
          } else {
            lockedContainer.scrollTop = scrollableContainer.scrollTop;
          }
        }
        /**
         * Adjusts given target table to hide its header in case when sticky header is present. Also, adds/removes a dummy header cell in sticky header to compansate for scrollbar width.
         * @param {HTMLTableElement} targetTable Reference to table element.
         * @param {HTMLElement} stickyContainer Reference to sticky container.
         * @param {HTMLElement} scrollEl Reference to scrollable element.
         */
  
      }, {
        key: "syncStickyHeader",
        value: function syncStickyHeader(targetTable, stickyContainer, scrollEl) {
          if (!stickyContainer || !targetTable || !scrollEl) {
            return;
          } // Compensate for scrolling
  
  
          var delta = scrollEl.offsetWidth - scrollEl.clientWidth;
          var bar = stickyContainer.querySelector('[bar]');
  
          if (delta) {
            if (!bar) {
              bar = document.createElement('td');
              bar.setAttribute('bar', 'true');
              stickyContainer.firstElementChild.thead.firstElementChild.appendChild(bar);
            }
  
            bar.style.width = delta + 'px';
          } else if (bar) {
            stickyContainer.firstElementChild.thead.firstElementChild.removeChild(bar);
          }
  
          var headerHeight = targetTable.querySelector('thead').offsetHeight;
          targetTable.style.marginTop = -headerHeight - 1 + 'px';
        }
        /**
         * Synchronizes the widths of each column for the given source and target tables.
         * @param {HTMLTableElement} srcTable Reference to the source table.
         * @param {HTMLTableElement} targetTable Reference to the target table.
         */
  
      }, {
        key: "syncTableWidths",
        value: function syncTableWidths(srcTable, targetTable) {
          // Need to match the width and height of headers in the sticky header and the table.
          // FF renders headers first and then resizes them.
          var cells = srcTable.querySelector('thead').querySelectorAll('td,th');
          var stickyCells = targetTable.querySelectorAll('td,th');
  
          for (var i = 0; i < cells.length; i++) {
            var cell = cells[i];
            var stickyCell = stickyCells[i];
  
            if (stickyCell) {
              stickyCell.style.whiteSpace = 'normal'; // Because parent white-space is nowrap
  
              stickyCell.style.width = cell.clientWidth + (cell.offsetLeft - stickyCell.offsetLeft) + 'px'; // IE11 we need to compensate 
  
              stickyCell.style.height = cell.clientHeight + cell.offsetHeight - cell.clientHeight + 'px'; // Why?
  
              stickyCell.style.minWidth = stickyCell.style.width;
              stickyCell.style.maxWidth = stickyCell.style.width;
            }
          }
        }
        /**
         * Synchronizes the scroll left position of the sticky container as that of scrollable container.
         */
  
      }, {
        key: "syncStickyHeaderScroll",
        value: function syncStickyHeaderScroll() {
          var stickyContainer = this.stickyHeaderContainer;
          var scrollableContainer = this.scrollableContainer;
          stickyContainer.scrollLeft = scrollableContainer.scrollLeft;
        }
      }, {
        key: "onrender",
        value: function onrender() {
          this._tablesRendered++;
  
          if (this._tablesRendered === this._expectedTablesCount + 1) {
            this.adjustTablePositions();
            this.fire('gridrender');
          }
        }
      }, {
        key: "onresize",
        value: function onresize() {
          var comp = this;
  
          if (!comp.resizeWaiting) {
            comp.resizeWaiting = true;
            window.requestAnimationFrame(function () {
              comp.resizeWaiting = false;
              comp.adjustTablePositions();
            });
          }
        }
      }, {
        key: "update",
        value: function update(data) {
          this.prepareTablesData(data);
  
          if (this.lockedColumns) {
            this.lockedTable.update(this.lockedTableData);
          }
  
          this.scrollableTable.update(this.scrollableTableData);
          this.adjustTablePositions();
        }
      }, {
        key: "onscroll",
        value: function onscroll(e) {
          if (this._scrollDebounce) {
            clearTimeout(this._scrollDebounce);
            delete this._scrollDebounce;
          }
  
          var self = this;
          this._scrollDebounce = setTimeout(function () {
            if (self.stickyHeader) {
              self.syncStickyHeaderScroll();
            }
  
            if (self.lockedColumns) {
              self.syncLockedTableScroll(e.target);
            }
  
            delete self._scrollDebounce;
          }, 0);
        }
      }, {
        key: "onmousedown",
        value: function onmousedown(e) {
          if (!this.resizable) {
            return;
          }
  
          var clientX = e.clientX || e.targetTouches[0].clientX;
  
          if (e.target.nodeName === 'TD' && (this.stickyTable.contains(e.target) || this.scrollableTable.contains(e.target)) && !e.target.hasAttribute('bar') && e.target.getBoundingClientRect().right - 5 < clientX) {
            this._startX = clientX;
            this._targetCell = e.target;
            this._initialWidth = e.target.offsetWidth;
            this._initialContainerHeight = this.scrollableContainer.clientHeight;
            this.on(['mousemove', 'touchmove', 'mouseup', 'touchend'], this, document);
          } else {
            this._startX = null;
            this._targetCell = null;
            this._initialWidth = null;
            this._initialContainerHeight = null;
            this.off(['mousemove', 'touchmove', 'mouseup', 'touchend'], this, document);
          }
        }
      }, {
        key: "onmousemove",
        value: function onmousemove(e) {
          if (this._targetCell && this._startX) {
            var displacement = (e.clientX || e.targetTouches[0].clientX) - this._startX;
            var cellIndex = this._targetCell.cellIndex; // Apply min-width to a common cell(i.e. first td in each row) in any given column so that we don't have to manage it for every row.
  
            var commonCell = this.scrollableTable.querySelectorAll('tr:first-child > td')[cellIndex];
            commonCell.style.minWidth = this._initialWidth + displacement + 'px';
  
            if (this.stickyHeader) {
              var headerCell = this.stickyTable.querySelectorAll('tr:first-child > td')[cellIndex];
              headerCell.style.minWidth = this._initialWidth + displacement + 'px'; // if column size is reduced, adjust the sticky header cell and non-sticky column
  
              if (displacement < 0) {
                var maxWidth = Math.max(commonCell.offsetWidth, headerCell.offsetWidth);
                commonCell.style.minWidth = headerCell.style.minWidth = maxWidth + 'px';
              }
            }
  
            if (this.lockedColumns && this._initialContainerHeight !== this.scrollableTable.clientHeight) {
              this.onresize();
            }
          }
        }
      }, {
        key: "onmouseup",
        value: function onmouseup(e) {
          if (this._targetCell && this._startX) {
            this._startX = null;
            this._targetCell = null;
            this._initialWidth = null;
            this._initialContainerHeight = null;
            this.off(['mousemove', 'touchmove', 'mouseup', 'touchend'], this, document);
          }
        }
      }, {
        key: "ontouchstart",
        value: function ontouchstart(e) {
          this.onmousedown(e);
        }
      }, {
        key: "ontouchmove",
        value: function ontouchmove(e) {
          this.onmousemove(e);
        }
      }, {
        key: "ontouchend",
        value: function ontouchend(e) {
          this.onmouseup(e);
        }
      }, {
        key: "onsort",
        value: function onsort(e) {
          this.sortColumn = e.detail.columnName;
          this.sortOrder = e.detail.order;
          this.fire('gridsort');
        }
        /**
        * Grid connect event handler
        * @param {CustomEvent} event 
        */
  
      }, {
        key: "ongridconnect",
        value: function ongridconnect(event) {}
        /**
         * Grid render event handler
         * @param {CustomEvent} event 
         */
  
      }, {
        key: "ongridrender",
        value: function ongridrender(event) {}
        /**
         * Grid render event handler
         * @param {CustomEvent} event 
         */
  
      }, {
        key: "ongridsort",
        value: function ongridsort(event) {}
      }, {
        key: "defaults",
        get: function get() {
          return {
            stickyHeader: false,
            lockedColumns: false,
            resizable: false
          };
        }
      }, {
        key: "scrollableTable",
        get: function get() {
          var table = this.scrollableContainer.firstChild;
  
          if (!table) {
            table = document.createElement(this.tableTagName, {
              is: this.tableIs
            });
            table.classList.add('zs-table');
            this.scrollableContainer.appendChild(table);
          }
  
          return table;
        }
        /**
         * Table that denotes locked part of the Grid.
         * @returns {HTMLTableElement} Instance of base Table component.
         */
  
      }, {
        key: "lockedTable",
        get: function get() {
          var table = this.lockedColumnContainer.firstChild;
  
          if (!table) {
            table = document.createElement(this.tableTagName, {
              is: this.tableIs
            });
            table.classList.add('zs-table');
            this.lockedColumnContainer.appendChild(table);
          }
  
          return table;
        }
        /**
         * Table that denotes sticky part of the Grid.
         * @returns {HTMLTableElement} Instance of base Table component.
         */
  
      }, {
        key: "stickyTable",
        get: function get() {
          var table = this.stickyHeaderContainer.firstChild;
  
          if (!table) {
            table = document.createElement(this.tableTagName, {
              is: this.tableIs
            });
            table.classList.add('zs-table');
            this.stickyHeaderContainer.appendChild(table);
          }
  
          return table;
        }
        /**
         * Table that denotes locked and sticky part of the Grid.
         * @returns {HTMLTableElement} Instance of base Table component.
         */
  
      }, {
        key: "lockedStickyTable",
        get: function get() {
          var table = this.lockedStickyHeaderContainer.firstChild;
  
          if (!table) {
            table = document.createElement(this.tableTagName, {
              is: this.tableIs
            });
            table.classList.add('zs-table');
            this.lockedStickyHeaderContainer.appendChild(table);
          }
  
          return table;
        }
        /**
         * Container containing scrollable Table of the Grid.
         * @returns {HTMLDivElement} Reference to the container.
         */
  
      }, {
        key: "scrollableContainer",
        get: function get() {
          var el = this.querySelector('[scrollable-container]');
  
          if (!el) {
            el = document.createElement('div');
            el.setAttribute('scrollable-container', '');
            el.classList.add('zs-scrollable');
            this.appendChild(el);
            this.on('scroll', this, el);
          }
  
          return el;
        }
        /**
         * Container containing locked Table of the Grid.
         * @returns {HTMLDivElement} Reference to the container.
         */
  
      }, {
        key: "lockedColumnContainer",
        get: function get() {
          var el = this.querySelector('[locked-column-container]');
  
          if (!el) {
            el = document.createElement('div');
            el.setAttribute('locked-column-container', '');
            el.classList.add('zs-fixed');
            this.appendChild(el);
            this.on('scroll', this, el);
          }
  
          return el;
        }
        /**
         * Container containing sticky Table of the Grid.
         * @returns {HTMLDivElement} Reference to the container.
         */
  
      }, {
        key: "stickyHeaderContainer",
        get: function get() {
          var el = this.querySelector('[sticky-header-container]');
  
          if (!el) {
            el = document.createElement('div');
            el.setAttribute('sticky-header-container', '');
            el.classList.add('zs-sticky');
            this.appendChild(el);
          }
  
          return el;
        }
        /**
         * Container containing locked-sticky Table of the Grid.
         * @returns {HTMLDivElement} Reference to the container.
         */
  
      }, {
        key: "lockedStickyHeaderContainer",
        get: function get() {
          var el = this.querySelector('[locked-sticky-header-container]');
  
          if (!el) {
            el = document.createElement('div');
            el.setAttribute('locked-sticky-header-container', '');
            el.classList.add('zs-sticky');
            this.appendChild(el);
          }
  
          return el;
        }
      }], [{
        key: "define",
        value: function define(tagName, tableIs, tableTagName) {
          var Cls = this;
          tableIs = tableIs || 'zs-table';
          tableTagName = tableTagName || 'table';
  
          if (!customElements.get(tableIs)) {
            _tableM["default"].define(tableIs, tableTagName);
          }
  
          Cls.prototype.tableIs = tableIs;
          Cls.prototype.tableTagName = tableTagName;
          tagName = tagName || 'zs-grid';
          return customElements.define(tagName, Cls);
        }
      }, {
        key: "observedAttributes",
        get: function get() {
          return ['sticky-header', 'locked-columns', 'resizable', 'ongridsort', 'ongridconnect', 'ongridrender'];
        }
      }]);
  
      return Grid;
    }(Base);
  
    _exports["default"] = Grid;
  });
  //# sourceMappingURL=grid.js.map